import { Avatar, Button, Chip, CircularProgress, Divider, Drawer, Grid, IconButton, InputAdornment, Modal, Skeleton, Tab, Table, TableBody, TableCell, TableHead, TableRow, Tabs, TextField, tableCellClasses } from '@mui/material';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import Box from '@mui/material/Box';
import { GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { PermissionsEnum } from "../../utils/auth.types";

import NavigateBeforeOutlinedIcon from '@mui/icons-material/NavigateBeforeOutlined';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { Inventory } from '../../utils/inventory.types';

import styled_ from "@emotion/styled";
import { makeStyles } from '@material-ui/core';
import DeleteIcon from '@mui/icons-material/Delete';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import { styled } from '@mui/material/styles';
import { SearchIcon } from 'lucide-react';
import moment from 'moment';
import { useNavigate, useParams } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import DefaultImg1 from '../../components/Employee/defaultImg.png';
import DefaultEmpImg from '../../components/Employee/product.png';
import { TabPanel } from '../Dialog/TabPanel';
// import AdjustStock from './AdjustStock';
// import PartyPrice from './PartyPrice';

// import { CustomerAgreedServices } from '../../utils/customer.types'
import { fetchCustomersById, fetchCustomersWithFilters, updateServicesCustomerById, fetchPartyOpeningBalanceHistory } from '../../store/customerStore/customerThunk';
import { deleteEmpAttachment, fetchEmployeeById } from '../../store/employeeStore/employeeThunk';

import { IAddress } from '../../utils/address.types';
import DialogAddressForm from '../DialogAddressForm/DialogAddressForm';
import DocAttachInfo from '../DocumentAttachment/DocAttachInfo';
import AdjustPartyOpeningBalance from './AdjustPartyOpeningBalance';
import PartyPaymentHistory from './PartyPaymentHistory';


const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

export const StyledBoxLoader = styled(Box)`
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fffffff2;
  z-index: 9999999;

  .MuiCircularProgress-root {
    left: 50%;
    top: 10%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    position: relative;
  }
`;

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  transition: '0ms',
  width: 425,
  borderRadius: 2,
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
};

const images = [
  {
    label: 'San Francisco – Oakland Bay Bridge, United States',
    imgPath:
      'https://images.unsplash.com/photo-1537944434965-cf4679d1a598?auto=format&fit=crop&w=400&h=250&q=60',
  },
  {
    label: 'Bird',
    imgPath:
      'https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=400&h=250&q=60',
  },
  {
    label: 'Bali, Indonesia',
    imgPath:
      'https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&h=250',
  },
  {
    label: 'Goč, Serbia',
    imgPath:
      'https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60',
  },
];

const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: 3,
  width: 15,
  height: 15,
  boxShadow:
  //   theme.palette.mode === 'dark'
      // ? '0 0 0 1px rgb(16 22 26 / 40%) ' :
      'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor: 
  // theme.palette.mode === 'dark' ? '#394b59' : 
  '#f5f8fa',
  backgroundImage:
  //   theme.palette.mode === 'dark'
      // ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))' :
      'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: 
  //   theme.palette.mode === 'dark' ? '#30404d' : 
    '#ebf1f5',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background:
      // theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 
      'rgba(206,217,224,.5)',
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: '#137cbd',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: 15,
    height: 15,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: '#106ba3',
  },
});

const StyledTableCell = styled_(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#fff',
      color: '#9da7b7',
      borderTop: '0.25px solid #d9d4d4',
      borderBottom: '0.25px solid #d9d4d4',
      margin:0,
      padding:5,
      fontSize: 13,
      paddingLeft:'15px !important',
    },
    [`&.${tableCellClasses.footer}`]: {
      backgroundColor: '#f5f5f5',
      color: 'black',
      borderTop: '0.25px solid #d9d4d4',
      borderBottom: '0.25px solid #d9d4d4',
      left: 0,
      bottom: 0, // <-- KEY
      zIndex: 2,
      position: 'sticky'
    },
    [`&.${tableCellClasses.body}`]: {
      verticalAlign: 'super',
      fontSize: 14,
      fontWeight:'normal',
      color:'#292d35',
      padding: 5,
      border:'none',
      paddingLeft:'15px !important',
      margin:0
    },
  }));
  
  const StyledTableRow = styled_(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
      backgroundColor: '#fbfbfb',
      // border: '0.5px dashed #9da7b7',
    },
    '&:nth-of-type(odd)': {
        backgroundColor: '#e9ecf1',
        // border: '0.5px dashed #9da7b7',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
    },
  }));

  
  interface StyledTabsProps {
    children?: React.ReactNode;
    value: number;
    onChange: (event: React.SyntheticEvent, newValue: number) => void;
  }
  

  const StyledTabs = styled((props: StyledTabsProps) => (
    <Tabs
      {...props}
    />
  ))({
    backgroundColor: '#fafafaff',
    borderRadius: '12px',
    marginLeft: '10px',
    padding: '6px',
    minHeight: '48px',
    maxWidth: 'fit-content',
    '& .MuiTabs-flexContainer': {
      gap: '4px',
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '& .MuiTab-root': {
      textTransform: 'none',
      fontSize: '14px',
      fontWeight: 500,
      color: '#a0aec0',
      zIndex: 2,
      minWidth: 'auto',
      height: '36px',
      minHeight: '36px',
      padding: '8px 20px',
      borderRadius: '8px',
      transition: 'all 0.2s ease-in-out',
      '&:hover:not(.Mui-selected)': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        color: '#059669',
      },
      '&.Mui-selected': {
        backgroundColor: '#059669',
        color: '#ffffff',
        fontWeight: 600,
        boxShadow: '0 2px 8px rgba(5, 150, 105, 0.3)',
      },
    },
  });

  interface TabPanelProps {
    index: number;
    value: number;
  }
  
  const StyledTabPanel = styled((props: TabPanelProps) => (
    <TabPanel
      {...props}
    />
  ))({
    '& .MuiBox-root': {
      backgroundColor: 'transparent !important',
      padding: '0px !important'
    }
  });
  
  interface StyledTabProps {
    label: string;
  }
  
  const StyledTab = styled((props: StyledTabProps) => (
    <Tab disableRipple {...props} />
  ))(({ theme }) => ({
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    color: '#545454',
    '&.Mui-selected': {
      color: '#059669',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'rgba(100, 95, 228, 0.32)',
    },
  }));


interface EmployeeViewProps {
  type?: string;
}

interface CustomerAgreedServices {
    serviceCategory?: string;
    serviceName?: string;
    serviceBudget?: number;
    personnel?: number;
    startDate?: Date;
    endDate?: Date;
    data: any[]
}

const useStyles = makeStyles({
    paper: {
      border: "1.5px solid #e9ecf1",
      boxShadow: 'none',
      borderRadius: 7
    },
    toggleButtonGroup: {
      width: '100%',
    },
    toggleButton: {
      width: 15,
      height: 15,
      marginBottom: 2
    },
  
});

interface DoucumentProps {
  name : string;
  document: any
}

const BuyerSupplierView: FC<EmployeeViewProps> = (type) => {
  const { customerId } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const classes = useStyles();
  const { customers, status, openingBalanceHistory, openingBalanceHistoryStatus } = useAppSelector(state => state.customers);
  const customerDetails = useAppSelector(state => state.customers.customerDetails);
  const { permissions, selectedAccount } = useAppSelector(state => state.auth);
  const { countries } = useAppSelector(state => state.country);

  const [isLoading, setIsLoading] = useState(false);
  const [filterQuery, setFilterQuery] = useState('');

  const [document, setDocument] = useState<DoucumentProps>();
  const [documentModel, setDocumentModel] = useState(false);
  const [fetchData, setFetchData] = useState('');
  const canUpdateAccount = permissions?.includes(PermissionsEnum.Account_Update);
  const [shippingAddress, setShippingAddress] = useState('');
  const [billingAddress, setBillingAddress] = useState('');

  // address drawer
  const [open, setOpen] = useState(false);
  const [addressId, setAddress] = useState('');
  const [counterPartyFlag, setCounterPartyFlag] = useState(false);
  const [counterPartyId, setCounterPartyId] = useState('');

  const [agreedServices, setAgreedServices] = useState<CustomerAgreedServices>({
    serviceCategory: '',
    serviceName: '',
    serviceBudget: 0,
    personnel: 0,
    startDate: undefined,
    endDate: undefined,
    data: []
  });

  const { docs } = useAppSelector(state => state.docAttach);
  const [docData, setDocData] = useState<any[]>([]);
  const [fetchDocs, setFetchDocs] = useState('');
  const [refreshDocs, setRefreshDocs] = useState(false);
  const [docDeleteId, setDocDeleteId] = useState("");

  const [value, setValue] = useState(0);

  // Opening Balance Adjustment States
  const [openAdjustDialog, setOpenAdjustDialog] = useState(false);
  const [refreshHistory, setRefreshHistory] = useState('');

  
  const openAddressForm = (addressId: string, counterPartyFlag: boolean = false) => {
    setAddress(addressId);
    setCounterPartyFlag(counterPartyFlag);
    if(customerDetails && customerDetails._id) {setCounterPartyId(customerDetails._id);}
    setOpen(true);
  }

  useEffect(() => {
    // Fetch account related customers if we are loading users on account details page.
    fetchCustomersList();
  }, [dispatch, selectedAccount, filterQuery]);


  const fetchCustomersList = async () => {
    const { _id: id } = selectedAccount;
    if(filterQuery) {
      let filter = (filterQuery && filterQuery !== '') ? `&name=${filterQuery}` : '';
      await dispatch(fetchCustomersWithFilters({ accountId: id, params: filter, apiLimit: '10' }));
      setIsLoading(false);
    } else {
      await dispatch(fetchCustomersWithFilters({ accountId: id, params: '', apiLimit: '10' }));
      setIsLoading(false);
    }
  }

  const closeDialog = (isSaved: boolean) => {
    setOpen(false);

    if(isSaved) {
      setFetchData(Math.random().toString());
    }
  }

  const handleNameClick = useCallback((address: IAddress) => {
    openAddressForm(address._id);
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  // fetch current customer details
  useEffect(() => {
    if (customerId) {
      setIsLoading(true);
      dispatch(fetchCustomersById(customerId));
      setIsLoading(false);
    }
  }, [customerId, fetchData, dispatch]);

  // Fetch opening balance history when customerId changes or after adjustment
  useEffect(() => {
    if (customerId && value === 4) { // Only fetch when on Accounting tab (index 4)
      dispatch(fetchPartyOpeningBalanceHistory(customerId));
    }
  }, [customerId, refreshHistory, value, dispatch]);

  const handleEditCustomerClick = useCallback(({_id}: Inventory) => {
    //Call edit function
    let navLink = `/customers/edit/${_id}`;
    navigate(navLink);
  }, []);

  const updateAgressServices = async () => {
    const data:any = {};
    const docsIds = docData.map(({ _id }) => _id);
    data.attachments = docsIds;

    if(agreedServices.data && agreedServices.data.length > 0) {
        data.agreedServices = agreedServices.data;
    } else {
        data.agreedServices = [];
    }
    if (customerId) {
        data.counterPartyId = customerId;
        // dispatch(updateServicesCustomerById(data));
        const resData: any = await dispatch(updateServicesCustomerById(data));
        if (resData.payload) {
            setFetchData(Math.random().toString());
        }
    }
  }


  const handleAddCustomer= () => {
    const navLink = `/customer/create`;
    navigate(navLink);
  };

  const handleDateChange = (newValue: Date | null, name: string | undefined) => {
    if (newValue) {
      if (name === 'startDate')
        setAgreedServices({ ...agreedServices, startDate : newValue});
      else if (name === 'endDate')
        setAgreedServices({ ...agreedServices, endDate : newValue});
    }
  };

  /** 
    * Column defs for address list data grid.
  */
  const columns: GridColDef[] = useMemo(() => [

    {
      field: "CourseName",
      headerName: 'Course Name/Type',
      type: "string",
      width: 150,
      renderCell: ({ row, value }: GridValueGetterParams) => {
          
          return (
            <p>{row.educationEstablishment} <br/> {row.courseDescription} </p>
          )
      }
    },
    {
      field: "university",
      headerName: 'University & School/College',
      type: "string",
      width: 300,
      renderCell: ({ row, value }: GridValueGetterParams) => {
          
          return (
            <p>{row.university} <br /> {row.schoolCollegeName}</p>
          )
      }
    },
    {
      field: "yearOfPassing",
      headerName: 'YOP',
      type: "string",
      width: 90,
      renderCell: ({ row, value }: GridValueGetterParams) => {
          
          return (
            <p>{row.yearOfPassing}</p>
          )
      }
    },
    {
      field: "percentage",
      headerName: '%',
      type: "string",
      width: 70,
      renderCell: ({ row, value }: GridValueGetterParams) => {
          
          return (
            <p>{row.percentage}</p>
          )
      }
    },
    {
      field: "startDate",
      headerName: 'Start Date',
      type: "string",
      width: 100,
      renderCell: ({ row, value }: GridValueGetterParams) => {
          
          return (
            <p>{row.startDate}</p>
          )
      }
    },
    {
      field: "endDate",
      headerName: 'End Date',
      type: "string",
      width: 100,
      renderCell: ({ row, value }: GridValueGetterParams) => {
          
          return (
            <p>{row.endDate}</p>
          )
      }
    },
  ], []);

  /** 
    * Column defs for Employee Prev Employer list data grid.
  */
  const columnsPrevEmployer: GridColDef[] = useMemo(() => [

    {
      field: "employerName",
      headerName: 'Employer Name',
      type: "string",
      width: 300,
      renderCell: ({ row, value }: GridValueGetterParams) => {
          
          return (
            <p>{row.name} <br/> 
            <span style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>
              {moment(row.start_date).format("DD MMM YYYY")} -- {moment(row.end_date).format("DD MMM YYYY")} </span>
              </p>
          )
      }
    },
    {
      field: "title",
      headerName: 'Title',
      type: "string",
      width: 150,
      renderCell: ({ row, value }: GridValueGetterParams) => {
          
          return (
            <p>{row.title}</p>
          )
      }
    },
    {
      field: "grossSalary",
      headerName: 'Gross Salary',
      type: "string",
      width: 150,
      renderCell: ({ row, value }: GridValueGetterParams) => {
          
          return (
            <p>{row.gross_salary}</p>
          )
      }
    },
    {
      field: "ctc",
      headerName: 'CTC',
      type: "string",
      width: 150,
      renderCell: ({ row, value }: GridValueGetterParams) => {
          
          return (
            <p>{row.ctc}</p>
          )
      }
    },
    {
      field: "isCurrentEmployer",
      headerName: 'Current Employer',
      type: "string",
      width: 100,
      renderCell: ({ row, value }: GridValueGetterParams) => {
          
          return (
            <p>{row.isCurrentEmployer ? 'Yes': 'No'}</p>
          )
      }
    },
  ], []);

  const handleEditEmployeeClick = useCallback((_id:any) => {
    //Call edit function
    let navLink = `/people/employee/edit/${_id}`;
    navigate(navLink);

  }, []);

  const handleAddEmployee= () => {
    const navLink = `/people/employee/create`;
    navigate(navLink);
  };

  const handleBackButtonClick = useCallback(() => {
    //Call edit function
    let navLink = `/buyers`;
    navigate(navLink);

  }, []);

  const handleCustomerDeleteAttachment = async (attachmentName: any) => {
    let data: any = {};
    if(attachmentName == 'logo') {
      data.logo = true;
    }
    console.log("called handleEmpDeleteAttachment", data);

    // try {
    //   await dispatch(deleteEmpAttachment({
    //     id: customerDetails._id,
    //     employeePayload: data,
    //   })).then((data) => {
    //     if (data) {
    //       dispatch(fetchEmployeeById(customerDetails._id));
    //       // handleClose();
    //     }
    //   }).catch(e => {
    //     //console.log(e);
    //   });;
    // } catch (error: any) {
    //   // Empty catch block.
    // }
  }

  const setAddesses = (object: any) => {
    if(object.addresses) {
        let address = object.addresses;
        let shipAdd = address.find((item: any) => item.type === 'Shipping') || [];
        let billAdd = address.find((item: any) => item.type === 'Billing') || [];
        if (shipAdd) {
        let _shippingAdddress = [shipAdd.line1, shipAdd.line2, shipAdd.city, shipAdd?.state?.name, shipAdd?.country?.name, shipAdd.code];
        setShippingAddress(_shippingAdddress.filter(n => n).join(", "));
        }
        if (billAdd) {
        let _billingAddress = [billAdd.line1, billAdd.line2, billAdd.city, billAdd?.state?.name, billAdd?.country?.name, billAdd.code];
        setBillingAddress(_billingAddress.filter(n => n).join(", "));
        }
    }
  };

  useEffect(() => {
    console.log('useeffect called debug');
    if(customerDetails) {
      setAddesses(customerDetails)
      setAgreedServices({
          serviceCategory: '',
          serviceName: '',
          serviceBudget: 0,
          personnel: 0,
          startDate: undefined,
          endDate: undefined,
          data: customerDetails.agreedServices
      });
      if(customerDetails.attachments && customerDetails.attachments.length > 0 ) {
        let docs = customerDetails.attachments
        let len = docs.length;
        setDocData(docs);
      }
    }
  }, [customerDetails]);

  const closeDocAttach = (isSaved: boolean) => {
    console.log("closeDocAttach Called ---")
    if (isSaved) {
      setRefreshDocs(true);
      setFetchDocs(Math.random().toString());
      setFetchData(Math.random().toString());
    }
  }
  const docDelete = (id: any) => {
    setDocDeleteId(id);
  }

  useEffect(() => {
    if (docDeleteId) {
      let docs = docData.filter(doc => doc._id !== docDeleteId);
      setDocData([...docs]);
      setDocDeleteId('');
    }
  }, [docDeleteId])
  
  useEffect(() => {
    if ((customerDetails.attachments) && fetchDocs && refreshDocs) {
      let docs = customerDetails.attachments
      let len = docs.length;
      setDocData(d => [...d, docs[len - 1]]);
    }
  }, [customerDetails.attachments, fetchDocs, refreshDocs])

  const searchQuery = async (searchValue:string)=> {
    setIsLoading(true);
    setFilterQuery(searchValue);
  }



  return (
    <>
      <Drawer anchor="right" open={open} >
          {<DialogAddressForm open={open} addressId={addressId} counterPartyFlag={counterPartyFlag} counterPartyId={counterPartyId} onClose={closeDialog}></DialogAddressForm>}
      </Drawer>
      {/* <Grid container p={0} spacing={2} position={'fixed'} mt={-2} zIndex={0}>
      <Grid item xs={8} >
      {customerDetails && <>
      <Box component="form" noValidate sx={{borderRadius:'12px', border:'3px solid #e9ecf1',backgroundColor:'#fff'}}>
        <Grid container>
          <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p:2, pl:2,pt:1.5, bgcolor:'#e9ecf1' }} style={{borderTopLeftRadius:8,borderTopRightRadius:8,height:50}} >
            
            <IconButton onClick={() => handleBackButtonClick()} style={{float:'left', color:'#545454', backgroundColor:'#f5f5f5',border:'none',height:35,width:35,marginTop:-5,marginRight:10,marginLeft:-5 }} size='small' >
              <NavigateBeforeOutlinedIcon style={{fontSize:20}} />
            </IconButton>
            <h3  style={{marginTop:-1,fontWeight:600}}>Customer : {customerDetails.legalName}</h3>              
          </Grid>
        </Grid>
      
      </Box>
      </>}
      </Grid>
      </Grid> */}

      <Grid container spacing={2}>
      <Grid item xs={9}>
        {/* {JSON.stringify(customerDetails)} */}
      
      <Box sx={{ bgcolor: '' }}>
        <StyledTabs value={value} onChange={handleChange} aria-label="styled tabs example">
          <StyledTab label="General"/>
          <StyledTab label="Documents" />
          <StyledTab label="Addresses" />
          <StyledTab label="Agreed Services" />
          <StyledTab label="Accounting" />
          <StyledTab label="Payment History" />
        </StyledTabs>
        <StyledTabPanel value={value} index={0} >
          <Grid container spacing={2} >
          {isLoading ? <StyledBoxLoader sx={{ mt: 1 }}><CircularProgress color="inherit" /></StyledBoxLoader> : ''}
            {customerDetails && <>
            <Grid item xs={3.5}>
              <div className={'c-card2'} style={{padding:12,paddingTop:12,textAlign:'center'}}>
                <img src={(customerDetails && customerDetails.logo) ? customerDetails.logo : DefaultImg1} style={{ width: '100%', height: 'auto',borderRadius:15,border:'.5px solid #e9ecf1',objectFit:'cover'}}/>
                <p style={{fontWeight:'normal',color:'#000',fontSize:15,marginTop:10}}>

                {(customerDetails && customerDetails.logo) && 
                  <Chip 
                    onClick={()=> { handleCustomerDeleteAttachment('logo'); }} 
                    size='small' 
                    style={{height:18,float:'right',borderRadius:7,color:'#c33b3b',backgroundColor:'#fbecec',fontSize:12}} 
                    label={<>Remove Logo<DeleteIcon style={{fontSize:12,float:'right',marginTop:'3px',marginLeft:'3px',marginRight:'-2px'}} /></>}
                  />
                }
                </p>
                <br/>
                <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13, textAlign: 'left'}}>Business Name </h5>
                <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:10, textAlign: 'left'}}>{customerDetails.name}</h5>

                <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13, textAlign: 'left'}}>Legal Name</h5>
                <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:10, textAlign: 'left'}}>{customerDetails.legalName}</h5>
                <Divider sx={{mt:2,mb:2}}/>
                
                <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13, textAlign: 'left'}}>GST Number</h5>
                <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:10, textAlign: 'left'}}>{customerDetails.taxIdentificationNumber2}</h5>

                <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13, textAlign: 'left'}}>PAN Number</h5>
                <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:10, textAlign: 'left'}}>{customerDetails.taxIdentificationNumber1}</h5>
              </div>
            </Grid>
            </>}
            <Grid item xs={8.5}>
              <div className={'c-card2'} style={{padding:15,paddingTop:10,paddingBottom:10}}>
                <h5 style={{fontWeight:'bold',color:'#000',fontSize:15}}>Business Information</h5>
                <Divider sx={{mt:0.5,mb:1}}/>
                {customerDetails && <>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13, textAlign: 'left'}}>Customer/Vendor/Agent{isLoading} </h5>
                      <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>
                        {customerDetails.isAgent && 
                          <Chip 
                            size='small' 
                            style={{
                              height:18, borderRadius:7,color:'#49a563',backgroundColor:'#edf6ef',
                              fontSize:11,marginTop:2,marginRight:3
                            }} 
                            label={<>Agent</>}
                          />
                        }
                        {customerDetails.isVendor && 
                          <Chip 
                            size='small' 
                            style={{
                              height:18, borderRadius:7,color:'#49a563',backgroundColor:'#edf6ef',
                              fontSize:11,marginTop:2,marginRight:3
                            }} 
                            label={<>Vendor</>}
                          />
                        }
                        {customerDetails.isClient && 
                          <Chip 
                            size='small' 
                            style={{
                              height:18, borderRadius:7,color:'#49a563',backgroundColor:'#edf6ef',
                              fontSize:11,marginTop:2,marginRight:3
                            }} 
                            label={<>Customer</>}
                          />
                        }
                      </h5>
                    </Grid>
                    <Grid item xs={12}>
                        <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Billing Address</h5>
                        <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{(billingAddress && billingAddress != '') ? billingAddress : '-'}</h5>
                    </Grid>
                    <Grid item xs={12}>
                        <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Shipping Address</h5>
                        <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{(shippingAddress && shippingAddress != '') ? shippingAddress : '-'}</h5>
                    </Grid>

                    <Grid item xs={4}>
                        <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Company Registration No</h5>
                        <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{(customerDetails && customerDetails.registrationNo) ? customerDetails.registrationNo : '-'}</h5>
                    </Grid>
                    <Grid item xs={4}>
                        <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>State of Registration</h5>
                        <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}> {(customerDetails && customerDetails.stateOfRegistration) ? `${customerDetails.stateOfRegistration.name}` : '-'}</h5>
                    </Grid>
                    <Grid item xs={4}>
                        <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Country Registration</h5>
                        <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{(customerDetails && customerDetails.countryOfRegistration) ? customerDetails.countryOfRegistration.name : '-'}</h5>
                    </Grid>
                </Grid>
                </>}
              </div>
              <div className={'c-card2'} style={{padding:15,paddingTop:10,paddingBottom:10,marginTop:15}}>
                <h5 style={{fontWeight:'bold',color:'#000',fontSize:15}}>Contact Details</h5>
                <Divider sx={{mt:0.5,mb:1}}/>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Contact Name</h5>
                    <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{(customerDetails && customerDetails.contactName) ? customerDetails.contactName : '-'}</h5>
                  </Grid>
                  <Grid item xs={4}>
                  <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>WhatsApp Number</h5>
                  <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}> {(customerDetails && customerDetails.whatsAppNumber) ? `+91 ${customerDetails.whatsAppNumber}` : '-'}</h5>
                  </Grid>
                  <Grid item xs={4}>
                  <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Website</h5>
                  <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{(customerDetails && customerDetails.website) ? customerDetails.website : '-'}</h5>
                  </Grid>
                  {customerDetails && customerDetails.isClient && <>
                  <Grid item xs={4}>
                  <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Date of Birth</h5>
                  <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{customerDetails.dateOfBirth ? moment(customerDetails.dateOfBirth).format('DD MMM YYYY') : '-'}</h5>
                  </Grid>
                  <Grid item xs={4}>
                  <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Age</h5>
                  <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{(customerDetails.age || customerDetails.age === 0) ? customerDetails.age : '-'}</h5>
                  </Grid>
                  <Grid item xs={4}>
                  <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Gender</h5>
                  <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>{customerDetails.gender ? customerDetails.gender : '-'}</h5>
                  </Grid>
                  </>}
                  <Grid item xs={12}>
                    <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Business Emails</h5>
                    {(customerDetails && customerDetails.email) && customerDetails.email.map((e:any) =>
                        <Chip 
                            size='small' 
                            style={{height:28,borderRadius:7,color:'#488dff',backgroundColor:'#e1e6ff',fontSize:12, marginRight: 10}}
                            label={e}
                        />
                    )}
                  </Grid>
                </Grid>
              </div>
              
            </Grid>
          </Grid>
        </StyledTabPanel>
        <StyledTabPanel value={value} index={1} >
          <Grid container spacing={2} >
            <Grid item xs={12}>
              {docData && <DocAttachInfo docList={docData} onDelete={docDelete} onClose={closeDocAttach} collectionName={'CounterParty'} collectionRefId={customerId} />}
            </Grid>
          </Grid>
        </StyledTabPanel>
        <StyledTabPanel value={value} index={2} >
            <Grid container spacing={2} >
                <Grid item xs={12}>
                    <div className={'c-card2'} style={{padding:0}}>
                        <Button
                            size='small'
                            variant="contained"
                            style={{float:"right",
                            color:'#488dff',
                            backgroundColor:'#fff',
                            border:'0.5px solid #488dff',
                            height:25,
                            borderRadius:7,
                            marginTop: 5,
                            marginRight: 10
                            }}
                            onClick={() => { openAddressForm('', true) }}
                        >Add Address
                        </Button>
                        <h5 style={{fontWeight:'bold',color:'#000',fontSize:15,marginLeft:15,marginTop:7}}>Business Addresses</h5>
                        {customerDetails.addresses && customerDetails.addresses.length > 0 ? 
                            <div style={{marginBottom:12,marginTop:5}}>
                                <Table stickyHeader sx={{ width: '100%'}} size='small' aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell width={100}>Type</StyledTableCell>
                                        <StyledTableCell width={150}>City</StyledTableCell>
                                        <StyledTableCell width={150}>State</StyledTableCell>
                                        <StyledTableCell width={150}>Country</StyledTableCell>
                                        <StyledTableCell width={400}>Address</StyledTableCell>
                                        <StyledTableCell width={50}>Action</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {customerDetails.addresses.map((e:any) => 
                                    <StyledTableRow key={e._id}>
                                    <StyledTableCell>{e.type}</StyledTableCell>   
                                        <StyledTableCell>{e.city}</StyledTableCell>   
                                        <StyledTableCell>{e.state?.name}</StyledTableCell>   
                                        <StyledTableCell>{e.country?.name}</StyledTableCell>   
                                        <StyledTableCell>{`${e.line1} ${e.line2} ${e.code}`} <br/> {`Phone1: ${e.phone1 ? e.phone1 : ''}`} <br/> {`Phone2: ${e.phone2 ? e.phone2 : ''}`} </StyledTableCell>  
                                        <StyledTableCell>
                                        <IconButton 
                                        style={{color:'#488dff',backgroundColor:'#fff',border:'0.1px solid #488dff',height:35,width:35, marginRight:10}}
                                        size='small' ><EditIcon style={{fontSize:16}} onClick={() => handleNameClick(e)}/>
                                        
                                    </IconButton>
                                    
                                        </StyledTableCell>  
                                    </StyledTableRow>
                                )}
                                </TableBody>
                                </Table>
                            </div> :
                            <div style={{height:200}}>
                                <Divider sx={{mt:0.5,mb:1}}/>
                                <span style={{marginLeft:15}}>No Data</span> 
                            </div>
                        }
                    </div>
                </Grid>
            </Grid>
        </StyledTabPanel>
        <StyledTabPanel value={value} index={3} >
            <Grid container spacing={2} >
                <Grid item xs={12}>
                    {agreedServices.data && 
                    <div className={'c-card2'} style={{padding:0}}>
                        <Button
                            disabled={!(agreedServices.serviceCategory && agreedServices.serviceName)}
                            size='small'
                            variant="contained"
                            style={{float:"right",
                            color:!(agreedServices.serviceCategory && agreedServices.serviceName) ? '#9da7b7' : '#488dff',
                            backgroundColor:'#fff',
                            border:!(agreedServices.serviceCategory && agreedServices.serviceName) ? '0.5px solid #9da7b7' :'0.5px solid #488dff',
                            height:25,borderRadius:7,marginTop: 5,marginRight: 10
                            }}
                            onClick={(e) => {
                            const e_data = [...agreedServices.data];
                            e_data.push({
                                uid: agreedServices.data.length + 1,
                                serviceCategory: agreedServices.serviceCategory,
                                serviceName: agreedServices.serviceName,
                                serviceBudget: agreedServices.serviceBudget,
                                personnel: agreedServices.personnel,
                                startDate: agreedServices.startDate,
                                endDate: agreedServices.endDate
                            });
                            setAgreedServices({ serviceCategory: '',serviceName:'', serviceBudget: 0, personnel: 0, startDate: undefined, endDate: undefined, data: e_data });
                            }} >
                            Add Row
                        </Button>
                        
                        <h5 style={{fontWeight:'bold',color:'#000',fontSize:15,marginLeft:15,marginTop:7}}>Agreed Services</h5>
                        <Divider sx={{mb:1}}/>
                        {/* {JSON.stringify(agreedServices)} */}
                        <LocalizationProvider dateAdapter={AdapterDateFns}>

                        <Grid container spacing={2} style={{padding: 15}}>

                            <Grid item xs={4}>
                                <h5 className='c-label2'>Service Category *</h5>
                                <TextField 
                                    placeholder="Service Category"
                                    disabled={agreedServices.data.length === 6}
                                    value={agreedServices.serviceCategory}
                                    onChange={(e) => setAgreedServices({ ...agreedServices, serviceCategory : e.target.value })}
                                    className='c-text-field-4' 
                                    variant="standard" 
                                    sx={{width:'100%',mt:0.5,borderRadius:'8px!important'}} 
                                    size='small'
                                    InputProps={{
                                    disableUnderline: true,
                                    }}
                                />
                                {/* <p style={{color: "#c33b3b"}}>{methods.formState.errors.fullName?.message ?? ""}</p> */}
                            </Grid>
                            <Grid item xs={4}>
                                <h5 className='c-label2'>Service Name *</h5>
                                <TextField 
                                    placeholder=""
                                    disabled={agreedServices.data.length === 6}
                                    value={agreedServices.serviceName}
                                    onChange={(e) => setAgreedServices({ ...agreedServices, serviceName : e.target.value })}
                                    className='c-text-field-4' 
                                    variant="standard" 
                                    sx={{width:'100%',mt:0.5,borderRadius:'8px!important'}} 
                                    size='small'
                                    InputProps={{
                                    disableUnderline: true,
                                    }}
                                />
                                {/* <p style={{color: "#c33b3b"}}>{methods.formState.errors.fullName?.message ?? ""}</p> */}
                            </Grid>
                            <Grid item xs={4}>
                                <h5 className='c-label2'>Service Budget *</h5>
                                <TextField 
                                    placeholder=""
                                    type='number'
                                    disabled={agreedServices.data.length === 6}
                                    value={agreedServices.serviceBudget}
                                    onChange={(e) => setAgreedServices({ ...agreedServices, serviceBudget : Number(e.target.value) })}
                                    className='c-text-field-4' 
                                    variant="standard" 
                                    sx={{width:'100%',mt:0.5,borderRadius:'8px!important'}} 
                                    size='small'
                                    InputProps={{
                                    disableUnderline: true,
                                    }}
                                />
                                {/* <p style={{color: "#c33b3b"}}>{methods.formState.errors.fullName?.message ?? ""}</p> */}
                            </Grid>
                            <Grid item xs={4}>
                                <h5 className='c-label2'>Personnel *</h5>
                                <TextField 
                                    placeholder="Personnel"
                                    type='number'
                                    disabled={agreedServices.data.length === 6}
                                    value={agreedServices.personnel}
                                    onChange={(e) => setAgreedServices({ ...agreedServices, personnel : Number(e.target.value) })}
                                    className='c-text-field-4' 
                                    variant="standard" 
                                    sx={{width:'100%',mt:0.5,borderRadius:'8px!important'}} 
                                    size='small'
                                    InputProps={{
                                    disableUnderline: true,
                                    }}
                                />
                                {/* <p style={{color: "#c33b3b"}}>{methods.formState.errors.fullName?.message ?? ""}</p> */}
                            </Grid>
                            <Grid item xs={4}>
                                <h5 className='c-label2'>Service Start Date *</h5>
                                <DesktopDatePicker
                                    inputFormat="dd MMM yyyy"
                                    disabled={agreedServices.data.length === 6}
                                    value={agreedServices.startDate || null}
                                    onChange={(value) => { handleDateChange(value, 'startDate') }}
                                    maxDate={moment().add(1).toDate()}
                                    InputProps={{
                                    disableUnderline: true,
                                    style:{
                                        fontSize:14,
                                        height:28
                                    },
                                    }}
                                    renderInput={(params) => 
                                    <TextField {...params}
                                        value={agreedServices.startDate || null}
                                        className='c-text-field-4' 
                                        variant="standard" 
                                        sx={{width:'100%',mt:0.5,borderRadius:'8px!important'}} 
                                        size='small'
                                        placeholder="Service Start Date"
                                    />
                                    }
                                />
                                {/* <p style={{color: "#c33b3b"}}>{methods.formState.errors.fullName?.message ?? ""}</p> */}
                            </Grid>
                            <Grid item xs={4}>
                                <h5 className='c-label2'>Service End Date *</h5>
                                <DesktopDatePicker
                                    inputFormat="dd MMM yyyy"
                                    disabled={agreedServices.data.length === 6}
                                    value={agreedServices.endDate || null}
                                    onChange={(value) => { handleDateChange(value, 'endDate') }}
                                    maxDate={moment().add(1).toDate()}
                                    InputProps={{
                                    disableUnderline: true,
                                    style:{
                                        fontSize:14,
                                        height:28
                                    },
                                    }}
                                    renderInput={(params) => 
                                    <TextField {...params}
                                        value={agreedServices.endDate || null}
                                        className='c-text-field-4' 
                                        variant="standard" 
                                        sx={{width:'100%',mt:0.5,borderRadius:'8px!important'}} 
                                        size='small'
                                        placeholder="Service End Date"
                                    />
                                    }
                                />
                                {/* <p style={{color: "#c33b3b"}}>{methods.formState.errors.fullName?.message ?? ""}</p> */}
                            </Grid>
                        </Grid>
                        </LocalizationProvider>

                            


                        {agreedServices.data && agreedServices.data.length > 0 && 
                            <div style={{marginBottom:12,marginTop:5}}>
                                <Table stickyHeader sx={{ width: '100%'}} size='small' aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell width={180}>Service Category</StyledTableCell>
                                        <StyledTableCell width={180}>Service Name</StyledTableCell>
                                        <StyledTableCell width={100}>Budget</StyledTableCell>
                                        <StyledTableCell width={100}>Personnel</StyledTableCell>
                                        <StyledTableCell width={100}>Start Date</StyledTableCell>
                                        <StyledTableCell width={100}>End Date</StyledTableCell>
                                        <StyledTableCell width={160}>
                                            <Button
                                                size='small'
                                                variant="contained"
                                                style={{float:"right",
                                                color:'#488dff',
                                                backgroundColor:'#fff',
                                                border:'0.5px solid #488dff',
                                                height:25,
                                                borderRadius:7,
                                                marginTop: 5,
                                                marginRight: 10,
                                                fontSize:12
                                                }}
                                                onClick={() => { updateAgressServices() }} >
                                                Update Services
                                            </Button>
                                        </StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {agreedServices.data.map(e => 
                                    <StyledTableRow key={e.uid}>
                                    <StyledTableCell>{e.serviceCategory}</StyledTableCell>   
                                        <StyledTableCell>{e.serviceName}</StyledTableCell>   
                                        <StyledTableCell>{e.serviceBudget}</StyledTableCell>   
                                        <StyledTableCell>{e.personnel}</StyledTableCell>   
                                        <StyledTableCell>{moment(e.startDate).format("DD MMM YYYY")}</StyledTableCell>  
                                        <StyledTableCell>{moment(e.endDate).format("DD MMM YYYY")}</StyledTableCell>  
                                        <StyledTableCell style={{textAlign:'center'}}>
                                            <IconButton 
                                                onClick={()=> {
                                                const rows = agreedServices.data.filter((obj) => obj.uid !== e.uid);
                                                setAgreedServices({ serviceCategory: '', serviceName:'', serviceBudget: 0, personnel: 0, startDate: undefined, endDate: undefined, data: rows });
                                                }}  
                                                style={{color:'#c33b3b',backgroundColor:'#fff',height:25,width:25,marginLeft:10 }}
                                                size='small'>
                                                <DeleteIcon style={{fontSize:16}}/>
                                            </IconButton>
                                        </StyledTableCell> 
                                    </StyledTableRow>
                                )}
                                </TableBody>
                                </Table>
                            </div>
                        }
                    </div>
                    }
                </Grid>
            </Grid>
        </StyledTabPanel>
        <StyledTabPanel value={value} index={4} >
          <Grid container spacing={2} >
            <Grid item xs={12}>
              <div className={'c-card2'} style={{padding:0}}>
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginRight:15}}>
                  <h5 style={{fontWeight:'bold',color:'#000',fontSize:15,marginLeft:15,marginTop:7}}>Opening Balance Details</h5>
                  {customerDetails.openingBalance && customerDetails.openingBalance.amount > 0 && (
                    <Button
                      size='small'
                      variant="contained"
                      style={{
                        color:'#488dff',
                        backgroundColor:'#fff',
                        border:'0.5px solid #488dff',
                        height:28,
                        borderRadius:7,
                        marginTop: 5,
                        fontSize: 13,
                        fontWeight: 500,
                        textTransform: 'none'
                      }}
                      onClick={() => setOpenAdjustDialog(true)}
                    >
                      Adjust Balance
                    </Button>
                  )}
                </div>

                {customerDetails.openingBalance && customerDetails.openingBalance.amount > 0 ?
                  <div style={{marginBottom:12,marginTop:5}}>
                    <Table stickyHeader sx={{ width: '100%'}} size='small' aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell width={150}>Financial Year</StyledTableCell>
                          <StyledTableCell width={120}>Balance Type</StyledTableCell>
                          <StyledTableCell width={150}>Amount</StyledTableCell>
                          <StyledTableCell width={200}>Description</StyledTableCell>
                          <StyledTableCell width={200}>Reason</StyledTableCell>
                          <StyledTableCell width={150}>Updated At</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <StyledTableRow>
                          <StyledTableCell>{customerDetails.openingBalance.financialYear || '-'}</StyledTableCell>
                          <StyledTableCell>
                            <Chip
                              size='small'
                              style={{
                                height:22,
                                borderRadius:7,
                                color: customerDetails.openingBalance.balanceType === 'Dr' ? '#c33b3b' : '#49a563',
                                backgroundColor: customerDetails.openingBalance.balanceType === 'Dr' ? '#fbecec' : '#edf6ef',
                                fontSize:12,
                                fontWeight: 600
                              }}
                              label={customerDetails.openingBalance.balanceType || '-'}
                            />
                          </StyledTableCell>
                          <StyledTableCell style={{fontWeight: 600}}>₹ {customerDetails.openingBalance.amount?.toLocaleString('en-IN') || '0'}</StyledTableCell>
                          <StyledTableCell>{customerDetails.openingBalance.description || '-'}</StyledTableCell>
                          <StyledTableCell>{customerDetails.openingBalance.reason || '-'}</StyledTableCell>
                          <StyledTableCell>{customerDetails.openingBalance.updatedAt ? moment(customerDetails.openingBalance.updatedAt).format("DD MMM YYYY") : '-'}</StyledTableCell>
                        </StyledTableRow>
                      </TableBody>
                    </Table>
                  </div> :
                  <div style={{height:200}}>
                    <Divider sx={{mt:0.5,mb:1}}/>
                    <span style={{marginLeft:15}}>No Data</span>
                  </div>
                }
              </div>
            </Grid>
            {/* <Grid item xs={12}>
              <div className={'c-card2'} style={{padding:0}}>
                <h5 style={{fontWeight:'bold',color:'#000',fontSize:15,marginLeft:15,marginTop:7}}>Previous Employment Details</h5>

                {customerDetails.prevEmployment && customerDetails.prevEmployment.length > 0 ?
                                    <div style={{marginBottom:12,marginTop:5}}>
                                      <Table stickyHeader sx={{ width: '100%'}} size='small' aria-label="customized table">
                                      <TableHead>
                                          <TableRow>
                                              <StyledTableCell width={235}>Employer Name</StyledTableCell>
                                              <StyledTableCell width={225}>Title</StyledTableCell>
                                              <StyledTableCell width={150}>Salary</StyledTableCell>
                                              <StyledTableCell width={150}>CTC</StyledTableCell>
                                              <StyledTableCell width={100}>Duration</StyledTableCell>
                                          </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {customerDetails.prevEmployment.map((e:any) =>
                                          <StyledTableRow key={e.id}>
                                            <StyledTableCell>{e.name}</StyledTableCell>
                                            <StyledTableCell>{e.title}</StyledTableCell>
                                            <StyledTableCell>{e.gross_salary}</StyledTableCell>
                                            <StyledTableCell>{e.ctc}</StyledTableCell>
                                            <StyledTableCell>{moment(e.start_date).format("YYYY")} - {moment(e.end_date).format("YYYY")}</StyledTableCell>
                                          </StyledTableRow>
                                        )}
                                      </TableBody>
                                      </Table>
                                    </div> :
                                    <div style={{height:200}}>
                                      <Divider sx={{mt:0.5,mb:1}}/>
                                      <span style={{marginLeft:15}}>No Data</span>
                                    </div>
                                    }
              </div>
            </Grid> */}

            {/* Opening Balance Adjustment History */}
            {customerDetails.openingBalance && customerDetails.openingBalance.amount > 0 && (
            <Grid item xs={12}>
              <div className={'c-card2'} style={{padding:0}}>
                <h5 style={{fontWeight:'bold',color:'#000',fontSize:15,marginLeft:15,marginTop:7}}>
                  Opening Balance Adjustment History
                </h5>

                {openingBalanceHistory && openingBalanceHistory.length > 0 ?
                  <div style={{marginBottom:12,marginTop:5}}>
                    <Table stickyHeader sx={{ width: '100%'}} size='small'>
                      <TableHead>
                        <TableRow>
                          <StyledTableCell width={140}>Type</StyledTableCell>
                          <StyledTableCell width={130}>Previous Balance</StyledTableCell>
                          <StyledTableCell width={110}>Change</StyledTableCell>
                          <StyledTableCell width={130}>New Balance</StyledTableCell>
                          <StyledTableCell width={200}>Reason</StyledTableCell>
                          <StyledTableCell width={150}>Journal Entry</StyledTableCell>
                          <StyledTableCell width={120}>Updated At</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {openingBalanceHistory.map((history: any) => (
                          <StyledTableRow key={history._id}>
                            <StyledTableCell>
                              {history.adjustmentType.split('_').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                            </StyledTableCell>
                            <StyledTableCell>
                              ₹{history.previousAmount.toLocaleString('en-IN')} {history.previousBalanceType}
                            </StyledTableCell>
                            <StyledTableCell>
                              <span style={{
                                color: history.changeType === 'increase' ? '#49a563' : '#c33b3b',
                                fontWeight: 600
                              }}>
                                {history.changeType === 'increase' ? '+' : '-'}₹{history.changeAmount.toLocaleString('en-IN')}
                              </span>
                            </StyledTableCell>
                            <StyledTableCell style={{fontWeight: 600}}>
                              ₹{history.newAmount.toLocaleString('en-IN')} {history.newBalanceType}
                            </StyledTableCell>
                            <StyledTableCell>{history.reason}</StyledTableCell>
                            <StyledTableCell>
                              {history.journalEntryId?.voucherNumber || '-'}
                            </StyledTableCell>
                            <StyledTableCell>
                              {moment(history.updatedAt || history.createdAt).format("DD MMM YYYY")}
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                :
                  <div style={{height:150}}>
                    <Divider sx={{mt:0.5,mb:1}}/>
                    <span style={{marginLeft:15}}>No adjustment history</span>
                  </div>
                }
              </div>
            </Grid>
            )}
          </Grid>

          {/* Adjust Opening Balance Dialog */}
          {openAdjustDialog && customerDetails && customerId && (
            <AdjustPartyOpeningBalance
              open={openAdjustDialog}
              onClose={(isSaved) => {
                setOpenAdjustDialog(false);
                if (isSaved) {
                  setFetchData(Math.random().toString()); // Refresh customer details
                  setRefreshHistory(Math.random().toString()); // Refresh history
                }
              }}
              partyId={customerId}
              partyName={customerDetails.legalName || customerDetails.name}
              currentOpeningBalance={{
                amount: customerDetails.openingBalance?.amount || 0,
                balanceType: customerDetails.openingBalance?.balanceType || 'Dr'
              }}
            />
          )}
        </StyledTabPanel>
        <StyledTabPanel value={value} index={5} >
          {/* Only mount when the tab is active so the payments APIs aren't hit on every party load */}
          {value === 5 && customerId && (
            <PartyPaymentHistory
              partyId={customerId}
              isClient={!!customerDetails?.isClient}
              isVendor={!!customerDetails?.isVendor}
            />
          )}
        </StyledTabPanel>
      </Box>
      </Grid>
      
          <Grid item xs={3} style={{height:'85vh', overflow:'auto'}} mt={3} pr={1}>
              <Grid container p={0} spacing={2} mt={-4}>
                  <Grid item xs={12}>
                    <h4>View More Customer</h4>
                    <TextField className='c-text-field-4' 
                      variant="standard" 
                      style={{width:'100%',marginTop:10}} 
                      size='small'
                      // value={filterQuery}
                      placeholder='Search by Name, GST No, Phone, Email'
                      onChange={(e)=> searchQuery(e.target.value.toString())}
                      InputProps={{
                        disableUnderline: true,
                        startAdornment: <InputAdornment position="start"><SearchIcon style={{marginTop:-3}} size={20}/></InputAdornment>,
                        style:{ 
                          fontSize:14,
                          fontWeight: 'normal',
                        },
                      }} 
                    />
                  </Grid>
                  
                  {/* {isLoading ? <Skeleton variant="rectangular" width={210} height={60} /> :`No Records Found` */}
                  { isLoading ?
                    <>
                    {[1,2,3,4,5].map((e:any) =>
                        <Grid item xs={12}>   
                          <div className={'c-card2'} style={{padding:10,paddingLeft:10}}>
                            <Grid container>
                              <Grid item xs={3.5}>
                              <Skeleton animation="wave" variant="circular" width={60} height={60} />
                              </Grid>
                              <Grid item xs={8}>
                              <Skeleton animation="wave" height={30} />
                              <Skeleton animation="wave" height={30} />
                              <Skeleton animation="wave" height={30} />
                              </Grid>
                            </Grid>
                          </div>
                        </Grid>
                    )} 
                    </>
                  : (customers && customers.length > 0) ? customers.map((e:any) =>
                      <Grid item xs={12} onClick={()=> navigate(`/customer/view/${e._id}`)}>
                        <div className={'c-card2'} style={{padding:10,paddingLeft:10}}>
                          <Grid container>
                            <Grid item xs={3.5}>
                              <Avatar
                                src={(e.logo && e.logo != "") ? e.logo : DefaultEmpImg}
                                sx={{ width: 60, height: 60 ,border:'.5px solid #e9ecf1',objectFit:'cover',padding:1, ml:1,mt:0.5,mb:0.5}}
                              />
                            </Grid>
                            <Grid item xs={8}>
                              <h5 style={{fontWeight:'normal',color:'#000',fontSize:14}}>
                                {(e.legalName.length > 20) ? `${e.legalName.substring(0, 20)} ...` : e.legalName}
                              </h5>
                              <p style={{fontSize:13}}>
                                
                                {e.email[0] && `${e.email[0]}`} {e.whatsAppNumber && e.whatsAppNumber }
                              </p>
                              <p style={{fontSize:13}}>
                                {e.isAgent && 
                                  <Chip 
                                    size='small' 
                                    style={{
                                      height:18, float: 'right', borderRadius:7,color:'#49a563',backgroundColor:'#edf6ef',
                                      fontSize:11,marginTop:2,marginRight:3
                                    }} 
                                    label={<>Agent</>}
                                  />
                                }
                                {e.isVendor && 
                                  <Chip 
                                    size='small' 
                                    style={{
                                      height:18, float: 'right', borderRadius:7,color:'#49a563',backgroundColor:'#edf6ef',
                                      fontSize:11,marginTop:2,marginRight:3
                                    }} 
                                    label={<>Vendor</>}
                                  />
                                }
                                {e.isClient && 
                                  <Chip 
                                    size='small' 
                                    style={{
                                      height:18, float: 'right', borderRadius:7,color:'#49a563',backgroundColor:'#edf6ef',
                                      fontSize:11,marginTop:2,marginRight:3
                                    }} 
                                    label={<>Customer</>}
                                  />
                                }
                              </p>

                            </Grid>
                          </Grid>
                        </div>
                      </Grid>
                    ) :

                    <>
                      <Grid item xs={12}>   
                        <div className={'c-card2'} style={{padding:10,paddingLeft:10}}>
                          <Grid container>
                            <Grid item xs={12}>
                              <p>No records found for the query</p>
                            </Grid>
                          </Grid>
                        </div>
                      </Grid>
                    </>
                    }
              </Grid>
        </Grid>

        
        </Grid>
    <Modal
        open={documentModel}
        onClose={(event : any, reason:any) => {
            if (reason !== 'backdropClick') {
              setDocumentModel(false)
            }
        }}
    >
        <Box sx={style}>
        <Grid container >
            <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p:2, pl:2, bgcolor:'#e9ecf1' }} style={{borderTopLeftRadius:8,borderTopRightRadius:8,height:50}} >
            <div style={{float:'right',marginTop:-7,marginRight:-5}}>
                {/* <IconButton size='small' >
                    <CheckCircleOutlineOutlinedIcon  color="primary"/>
                </IconButton> */}
                <IconButton size='small' onClick={()=> setDocumentModel(false)} style={{marginRight:-5}} >
                    <HighlightOffOutlinedIcon  color="error"/>
                </IconButton>
            </div>
            <h3  style={{marginTop:-2}}>{document?.name}</h3>
            {/* {JSON.stringify(selectedBank)} */}
            </Grid>
            
        </Grid>
        <img src={document?.document} style={{marginTop:5,width:'100%',height:'auto',padding:5,borderRadius:15,border:'.5px solid #e9ecf1',objectFit:'cover'}}/>
        </Box>
    </Modal>
    </>
  );
}
export default BuyerSupplierView;